import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PageShell from "../dashboard/PageShell";
import {
  ConferenceBasicInfo,
  ConferenceFileUpload,
  ConferenceFormActions,
} from "../../components/forms/ConferenceForm";

const AddNewConference: React.FC = () => {
  const navigate = useNavigate();
  const [files, setFiles] = useState<File[]>([]);
  const [formData, setFormData] = useState({
    vietnameseName: "",
    englishName: "",
    type: "",
    budget: "",
    budgetSource: "",
    executionTime: "",
    endTime: "",
    venue: "",
    vietnameseParticipants: "",
    foreignParticipants: "",
    hostUnit: "",
    conferenceChair: "",
    participants: "",
    speakers: "",
    mainContent: "",
    evaluation: "",
  });

  const handleInputChange = (field: string, value: string) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = () => {
    // Handle save logic here
    console.log("Saving conference data:", formData);
    console.log("Files:", files);
    // You can add API call here
  };

  const handleCancel = () => {
    navigate("/conferences-workshops");
  };

  return (
    <PageShell title="Thêm mới Hội nghị, hội thảo">
      <div className="space-y-4">
        {/* Header Section */}
        <div className="flex justify-between items-center">
          <h1 className="text-xl font-semibold text-gray-800">
            Thêm mới Hội nghị, hội thảo
          </h1>
        </div>

        {/* Form Section */}
        <div className="bg-white rounded-lg p-4">
          <div className="space-y-4">
            <ConferenceBasicInfo
              formData={formData}
              handleInputChange={handleInputChange}
            />

            <ConferenceFileUpload files={files} onFilesChange={setFiles} />
          </div>
        </div>

        <ConferenceFormActions onSave={handleSave} onCancel={handleCancel} />
      </div>
    </PageShell>
  );
};

export default AddNewConference;
